var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'center': true, 'hidden': !_vm.showError }},[_c('h1',[_vm._v(_vm._s(_vm.$t('linkInvalid')))]),_c('p',{staticClass:"btn-normal-2"},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v(_vm._s(_vm.$t('topPage')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }